import React, { FC, ReactElement, useMemo } from 'react';

import { ExpandableTextBlock } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { removeAllHTMLTags } from '@gem/utils';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';

import styles from './CalendarInfoDescription.styles.m.css';

const CALENDAR_INFO_DESCRIPTION_MAX_LENGTH = 155;

interface ICalendarInfoDescriptionProps {
  description: string;
}

export const CalendarInfoDescription: FC<ICalendarInfoDescriptionProps> = (props) => {
  const { t } = useTranslation();

  const description = useMemo(() => removeAllHTMLTags(props.description), [props.description]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('calendar_event_description')}</div>
      <ExpandableTextBlock
        className={styles.description}
        text={description}
        textMaxLength={CALENDAR_INFO_DESCRIPTION_MAX_LENGTH}
        renderTextFn={(text): ReactElement => <TextRenderer>{text}</TextRenderer>}
      />
    </div>
  );
};
